module.exports = __webpack_public_path__ + "img/kv-r.88aa2168.png";